"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contactProperties = contactProperties;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _RequestState = _interopRequireDefault(require("lead-flows-ui/utils/RequestState"));

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var INITIAL_STATE = {
  fetchRequestState: _RequestState.default.NOT_REQUESTED,
  groups: [],
  properties: [],
  creationErrorMessage: '',
  creationRequestState: _RequestState.default.NOT_REQUESTED
};

function contactProperties() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _ActionTypes.REQUEST_CONTACT_PROPERTIES:
      return Object.assign({}, state, {
        fetchRequestState: _RequestState.default.REQUEST_SUBMITTED
      });

    case _ActionTypes.RECEIVE_CONTACT_PROPERTIES:
      return Object.assign({}, state, {
        fetchRequestState: _RequestState.default.SUCCESS,
        groups: action.groups,
        properties: action.properties.map(function (property) {
          return (0, _extends2.default)({}, property, {
            propertyObjectType: 'CONTACT'
          });
        })
      });

    case _ActionTypes.HANDLE_CONTACT_PROPERTIES_FETCH_ERROR:
      return Object.assign({}, state, {
        fetchRequestState: _RequestState.default.ERROR
      });

    case _ActionTypes.REQUEST_CONTACT_PROPERTY_CREATION:
      return Object.assign({}, state, {
        creationRequestState: _RequestState.default.REQUEST_SUBMITTED,
        creationErrorMessage: ''
      });

    case _ActionTypes.HANDLE_PROPERTY_CREATION_SUCCESS:
      return Object.assign({}, state, {
        creationRequestState: _RequestState.default.SUCCESS,
        properties: state.properties.concat([action.property])
      });

    case _ActionTypes.HANDLE_PROPERTY_CREATION_ERROR:
      return Object.assign({}, state, {
        creationRequestState: _RequestState.default.ERROR.withMessage(action.message),
        creationErrorMessage: action.descreptiveMessage
      });

    default:
      return state;
  }
}